import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAvaliacaoRequisitoVagaDto, RespostaAvaliacaoRequisitoDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'modal-pre-visualizacao.component',
  templateUrl: './modal-pre-visualizacao.component.html',
  styleUrls: ['./modal-pre-visualizacao.component.scss']
})
export class ModalPreVisualizacaoComponent {
  perguntas: CreateAvaliacaoRequisitoVagaDto[] = [];
  
  constructor(public activeModal: NgbActiveModal) { }

  fechar() {
    this.activeModal.dismiss();
  }
}
